import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [config, setConfig] = useState({ brand_name: "CRIPTO CLUB", logo_url: "", mode: "REAL", rewards: {} });

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      return data.user;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refreshUser();
    api.get("/public/config").then(({ data }) => setConfig(data)).catch(() => {});
    const p = new URLSearchParams(window.location.search);
    const ref = p.get("ref");
    if (ref) localStorage.setItem("cc_ref", JSON.stringify({ code: ref.toUpperCase().slice(0, 16), ts: Date.now() }));
  }, [refreshUser]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* sesión ya cerrada */ }
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, refreshUser, logout, config, setConfig }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
